import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getStorageFileUrl } from "@/util/get-storage-file-url";

interface RebuildAvatarProps {
  photo?: string;
  initials?: string;
}
export const RebuildAvatar = ({ photo, initials }: RebuildAvatarProps) => {
  const src = !!photo && photo?.length > 0 ? (photo?.includes("http") ? photo : getStorageFileUrl(photo ?? "")) : "";

  return (
    <Avatar className="h-5 w-5">
      <AvatarImage data-testid="avatar" src={src} alt="avatar" />
      <AvatarFallback className="bg-black text-xs text-white">{initials ?? "U"}</AvatarFallback>
    </Avatar>
  );
};
